<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Восстанавливаем работу Finch"
      @hidden="emit('hidden')"
      :max-width="500"
      without-buttons
  >
    <template #default>
        <p class="service-recovery-modal__text mb-3">
            Хорошие новости — <b>звонки и онлайн-доски уже доступны!</b>
        </p>
        <p class="service-recovery-modal__text mb-1">Что пока не работает:</p>
        <ul class="service-recovery-modal__text mb-3 ps-4">
            <li>Запись звонков</li>
            <li>Отправка уведомлений по электронной почте</li>
        </ul>
        <div class="service-recovery-modal__text bg-primary text-white rounded-3 p-3 mb-3">
            <p class="fw-semibold mb-2">Как добавлять новых учеников?</p>
            <p class="mb-0">
                Пока отправка email-сообщений недоступна, вы можете добавлять новых учеников без подтверждения
                по электронной почте.
            </p>
        </div>
        <p class="service-recovery-modal__text mb-3">
            Мы продолжаем устранять оставшиеся неполадки и сообщим, когда все функции будут полностью восстановлены.
        </p>
        <p class="service-recovery-modal__text mb-3">
            Если у вас возникли вопросы, напишите нам на официальную почту службы поддержки:
            <a href="mailto:support@finch.study">support@finch.study</a>.
        </p>
        <p class="service-recovery-modal__text mb-3">Спасибо за терпение и понимание!</p>
        <p class="service-recovery-modal__text mb-0">
            С уважением<br />
            Команда Finch
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
// Модалка «Восстанавливаем работу Finch» (FINCH-2631). Чисто информационная:
// закрывается крестиком, факт показа фиксирует хост по событию hidden.
import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
}>();

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.service-recovery-modal__text {
    font-size: 14px;
}
</style>
